import PropTypes from 'prop-types';
import { Children, PureComponent } from 'react';
import { List } from 'immutable';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import cloneElement from 'SalesContentIndexUI/utils/cloneElement';
import IndexTableRowCellSlot from 'SalesContentIndexUI/slots/IndexTableRowCellSlot';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './In... Remove this comment to see the full error message
import IndexTableCheckboxCell from './IndexTableCheckboxCell';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import { assertPropsDefined } from '../utils/PropValidationUtils';
import { View } from 'foundations-components/components/View';
import { FolderIcon } from 'foundations-assets/icons/components/FolderIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default class IndexTableFolderRow extends PureComponent {
  constructor(...args) {
    super(...args);
    this.validateProps = () => {
      const {
        searchResult,
        selectionData,
        setSelectedFolder,
        toggleFolderSelection,
        isModal
      } = this.props;
      assertPropsDefined({
        searchResult,
        selectionData,
        setSelectedFolder,
        toggleFolderSelection,
        isModal
      });
    };
    this.getCells = () => {
      const {
        children,
        searchResult
      } = this.props;
      let cells = List();
      Children.forEach(children, child => {
        const childType = child ? child.type : '';
        switch (childType) {
          case IndexTableRowCellSlot:
            {
              const childWithProps = cloneElement(child, {
                key: `index-folder-row-cell-${searchResult.id}-${cells.size}}`,
                searchResult
              });
              cells = cells.push(childWithProps);
              break;
            }
          default:
            break;
        }
      });
      return cells;
    };
    this.handleOpen = () => {
      const {
        searchResult,
        setSelectedFolder
      } = this.props;
      setSelectedFolder(searchResult);
    };
    this.handleToggleSelection = () => {
      const {
        searchResult,
        toggleFolderSelection
      } = this.props;
      toggleFolderSelection(searchResult);
    };
    this.renderCheckboxCell = () => {
      const {
        selectionData,
        searchResult,
        isModal
      } = this.props;
      if (isModal) {
        return null;
      }
      return /*#__PURE__*/_jsx(IndexTableCheckboxCell, {
        contentId: searchResult.contentId,
        selectionData: selectionData,
        toggleSelection: this.handleToggleSelection,
        isFolder: true
      });
    };
    this.renderFolderCell = () => {
      return /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsxs(Link, {
          onClick: this.handleOpen,
          "data-selenium-test": "sales-content-index-table-folder-link",
          children: [/*#__PURE__*/_jsx(View, {
            as: "span",
            marginInlineEnd: "200",
            paddingBlockStart: "100",
            children: /*#__PURE__*/_jsx(FolderIcon, {
              alignWithText: true
            })
          }), this.props.searchResult.get('name')]
        })
      });
    };
  }
  render() {
    this.validateProps();
    return /*#__PURE__*/_jsx("tr", {
      "data-test-id": "sales-content-index-folder-row",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [this.renderCheckboxCell(), this.renderFolderCell(), this.getCells()]
      })
    });
  }
}
IndexTableFolderRow.propTypes = {
  children: PropTypes.any,
  searchResult: PropTypes.instanceOf(SearchResultRecord).isRequired,
  selectionData: PropTypes.object.isRequired,
  setSelectedFolder: PropTypes.func.isRequired,
  toggleFolderSelection: PropTypes.func.isRequired,
  isModal: PropTypes.bool.isRequired
};
IndexTableFolderRow.defaultProps = {
  isModal: false
};